import axios, {
  AxiosProgressEvent,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import { Buffer } from 'buffer';

export const UploadToS3 = async (
  presignedUrl: string,
  file: { type: string; uri: string },
  onUploadProgress?: (progressEvent: any) => void
) => {
  const options = {
    timeout: 2 * 60 * 1000,
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
    },
    onUploadProgress,
  };

  let base64Data = file.uri;

  // Handle base64 URIs that include metadata like "data:audio/mp3;base64,..."
  if (file.uri.startsWith('data:')) {
    // Remove prefix like "data:<mime-type>;base64,"
    base64Data = file.uri.replace(/^data:[^;]+;base64,/, '');
  }

  // Convert base64 to binary buffer
  const bufferValue = Buffer.from(base64Data, 'base64');

  // Use ArrayBuffer for Axios PUT (important for binary data)
  return axios.put(presignedUrl, bufferValue.buffer, options);
};

export const uploadVideoToS3 = async (
  presignedUrl: string,
  file: { type: string; uri: string },
  onUploadProgress?: (e: AxiosProgressEvent) => void
): Promise<AxiosResponse<any>> => {
  const progressCallback = onUploadProgress ?? (() => {});

  const config: AxiosRequestConfig = {
    timeout: 2 * 60 * 1000,
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress: progressCallback,
  };

  const resp = await fetch(file.uri);
  if (!resp.ok) {
    throw new Error(`Failed to fetch "${file.uri}": ${resp.statusText}`);
  }

  const arrayBuffer = await resp.arrayBuffer();
  const uint8 = new Uint8Array(arrayBuffer);

  return axios.put(presignedUrl, uint8, config);
};

export const RemoveFromS3 = (presignedUrl: string) => {
  const config = {
    method: 'delete',
    url: presignedUrl,
    headers: {
      Accept: 'application/json, text/plain, */*',
    },
    referrerPolicy: 'no-referrer',
  };

  axios(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      return true;
    })
    .catch((error) => {
      return false;
    });
  return true;
};

export const getS3FileSize = async (url: string) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
    });
    const contentLength = response.headers.get('Content-Length');
    return contentLength;
  } catch (error) {
    console.error('Error fetching file size:', error);
    return 0;
  }
};
